/**
 * defa.views.InvitationSubscriptionView
 * Gives the user the choice to approve or reject a subscription invitation.
 * @version 1.0.0
 */
import View from 'scripts/poppet/view';
import template from 'templates/invitationSubscriptionView.jst.html'
const selectors = {
	buttonAccept : '[data-click=subscription-accept]',
	buttonReject : '[data-click=subscription-reject]',
	errorText    : '[data-text=process-subscription-invitation-error]'
};

const InvitationSubscriptionView = View.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	template: template,
	
	ui: {
		reject: selectors.buttonReject,
		accept: selectors.buttonAccept,
		error: selectors.errorText
	},
	
	events: {
		'click @ui.accept' : 'onClickAccept',
		'click @ui.reject' : 'onClickReject'
	},
	
	templateContext: function() {
		return {
			alias : this.model.get('unit').alias
		}
	},
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		/**
		 * Triggers when clicking reject.
		 * @void
		 * //
		 */
	onClickReject: function ( event ) {
		event.preventDefault();
		let self = this;
		this.busy();
		this.model._reject( {
			token: self.options.token,
			invitationId:  self.options.invitationId,
			success: function ( options ) {
				self.idle();
			},
			error  : function ( errorMessage ) {
				self.idle();
				self.ui.error.append(errorMessage)
			}
		} );
	},
		
		
		/**
		 * Triggers when clicking accept.
		 * @void
		 */
	onClickAccept: function ( event ) {
		event.preventDefault();
		let self = this;
		this.busy();
		this.model._accept( {
			token: self.options.token,
			invitationId:  self.options.invitationId,
			success: function ( options ) {
				self.idle();
			},
			error  : function ( errorMessage ) {
				self.idle();
				self.ui.error.append(errorMessage)
				
			}
		} );
	}
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
});

export default InvitationSubscriptionView;
